const API_URL = process.env.REACT_APP_API_BASE_URL || '';

export class ContactsService {

    static async getAllContacts(authorizedFetch) {
        const res = await authorizedFetch(`${API_URL}/api/contacts`);
        if (!res.ok) throw new Error('Failed to fetch contacts');
        return res.json();
    }

    static async getContact(authorizedFetch, id) {
        const res = await authorizedFetch(`${API_URL}/api/contacts/${id}`);
        if (!res.ok) throw new Error('Failed to fetch contact');
        return res.json();
    }

    static async createContact(authorizedFetch, data) {
        const res = await authorizedFetch(`${API_URL}/api/contacts`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to create contact');
        }
        return res.json();
    }

    static async updateContact(authorizedFetch, id, data) {
        const res = await authorizedFetch(`${API_URL}/api/contacts/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to update contact');
        }
        return res.json();
    }

    static async deleteContact(authorizedFetch, id) {
        const res = await authorizedFetch(`${API_URL}/api/contacts/${id}`, {
            method: 'DELETE'
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to delete contact');
        }
        return res.json();
    }
}
